export class FiscalClosureConst {
  public static headerTable = [
    { field: 'mes', title: 'Mes', cell: (row) => `${row.mes}`, class: (row) => `` },
    { field: 'estado', title: 'Estado', cell: (row) => `${row.estado}`, class: (row) => `` },
  ];
}
